import type { Job } from "../types";

/** Statuts figés : on ne recalcule pas depuis la date. */
const TERMINAL_STATUSES: Job["status"][] = ["completed", "cancelled", "in_progress"];

/**
 * Statut à enregistrer : une date de RDV = dossier planifié (poseur optionnel).
 */
export function resolveJobStatusFromScheduling(
  status: Job["status"],
  date?: string | null
): Job["status"] {
  if (TERMINAL_STATUSES.includes(status)) return status;
  return date?.trim() ? "scheduled" : "pending";
}

/**
 * Statut affiché côté UI (corrige pending + date encore présents en base).
 */
export function getJobDisplayStatus(job: Pick<Job, "status" | "date">): Job["status"] {
  if (job.status === "pending" && job.date?.trim()) return "scheduled";
  return job.status;
}

export function jobHasScheduledAppointment(job: Pick<Job, "date">): boolean {
  return Boolean(job.date?.trim());
}
